import { ComponentPropsWithoutRef } from "react";
import { twMerge } from "tailwind-merge";
import { ButtonV2 } from "../../../../Atoms";

interface ICardItineranteStatProps {
  label: string;
  value: string;
}

const CardItineranteStat = ({ label, value }: ICardItineranteStatProps) => (
  <div className="flex flex-col sm:flex-1">
    <span className="text-[10px] tracking-[0.03em] text-[#595959]">
      {label}
    </span>
    <span className="text-base font-bold tracking-[0.03em] text-[#2d2d2d]">
      {value}
    </span>
  </div>
);

interface ICardItineranteProps extends ComponentPropsWithoutRef<"div"> {
  cidade: string;
  dataRealizacao: string;
  vagas: string;
  onSelect: () => void;
  striped?: boolean;
}

export const CardItinerante = ({
  cidade,
  dataRealizacao,
  vagas,
  onSelect,
  striped,
  className,
  ...rest
}: ICardItineranteProps) => {
  return (
    <div
      className={twMerge(
        "flex flex-col gap-4 rounded-[10px] p-5 sm:flex-row sm:items-center sm:justify-between sm:gap-4",
        striped ? "bg-[#f7f7f7]" : "bg-[#e8e8e8]",
        className,
      )}
      {...rest}
    >
      <div className="flex flex-col gap-3 sm:flex-1 sm:flex-row sm:gap-4">
        <CardItineranteStat label="Cidade:" value={cidade} />
        <CardItineranteStat
          label="Data de realização:"
          value={dataRealizacao}
        />
        <CardItineranteStat label="Vagas:" value={vagas} />
      </div>
      <ButtonV2 onClick={onSelect} className="w-full sm:w-auto">
        Selecionar
      </ButtonV2>
    </div>
  );
};
